import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="max-w-3xl mx-auto px-5 md:px-8 py-24 text-center">
      <Helmet>
        <title>Page introuvable | MARTIN NETTOYAGE</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1 className="font-heading font-extrabold text-5xl text-ink">404</h1>
      <p className="text-muted-foreground mt-4">Cette page n'existe pas ou a été déplacée.</p>
      <Link to="/" className="mt-8 inline-flex bg-ink text-white font-bold px-7 py-4 rounded-sm hover:bg-ink-light transition-colors">
        Retour à l'accueil
      </Link>
    </div>
  );
}
